/**
 * CS: Cart Drawer Fierce Club Upsell.
 * Web Component — morph-safe, works within <dialog> on iOS Safari.
 * Handles membership CTA, benefits toggle, and info popup.
 */
class CsCartUpsell extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', this.handleClick.bind(this), {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  async handleClick(e) {
    /* --- Add Membership CTA --- */
    const btn = e.target.closest('.cs-cart-upsell__cta');
    if (btn) {
      e.preventDefault();
      const variantId = parseInt(btn.dataset.variantId);
      const sellingPlan = parseInt(btn.dataset.sellingPlan);
      if (!variantId) return;

      const originalText = btn.textContent;
      btn.textContent = 'Adding\u2026';
      btn.disabled = true;
      this.classList.add('cs-cart-upsell__loading');

      const body = { items: [{ id: variantId, quantity: 1 }] };
      if (sellingPlan) body.items[0].selling_plan = sellingPlan;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();

        if (data.status) {
          btn.textContent = originalText;
          btn.disabled = false;
          this.classList.remove('cs-cart-upsell__loading');
          const errEl = this.querySelector('[data-cs-upsell-error]');
          if (errEl) {
            errEl.style.display = 'block';
            setTimeout(() => { errEl.style.display = 'none'; }, 5000);
          }
          return;
        }

        btn.textContent = 'Added!';

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              sourceId: 'cs-cart-upsell',
              data: { source: 'product-form-component', itemCount: 1 },
            },
          })
        );
      } catch {
        btn.textContent = originalText;
        btn.disabled = false;
        this.classList.remove('cs-cart-upsell__loading');
        const errEl = this.querySelector('[data-cs-upsell-error]');
        if (errEl) {
          errEl.style.display = 'block';
          setTimeout(() => { errEl.style.display = 'none'; }, 5000);
        }
      }
      return;
    }

    /* --- See all benefits toggle --- */
    const toggle = e.target.closest('[data-cs-benefits-toggle]');
    if (toggle) {
      const benefits = this.querySelector('[data-cs-benefits]');
      if (!benefits) return;
      const isOpen = benefits.getAttribute('data-open') === 'true';
      benefits.setAttribute('data-open', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      const arrow = toggle.querySelector('.cs-cart-upsell__toggle-arrow');
      if (arrow) arrow.textContent = isOpen ? '\u25BC' : '\u25B2';
      return;
    }

    /* --- Benefits info popup toggle --- */
    const infoBtn = e.target.closest('[data-cs-benefits-info-toggle]');
    if (infoBtn) {
      const popup = this.querySelector('[data-cs-benefits-info]');
      if (popup) popup.style.display = popup.style.display === 'none' ? 'block' : 'none';
      return;
    }

    /* --- Benefits info popup close --- */
    const closeBtn = e.target.closest('[data-cs-benefits-info-close]');
    if (closeBtn) {
      const popup = this.querySelector('[data-cs-benefits-info]');
      if (popup) popup.style.display = 'none';
    }
  }
}
customElements.define('cs-cart-upsell', CsCartUpsell);
